import { Injectable, Injector } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class ErrorMessages {

    constructor() { }

    //Message for valid attachment.
    validAttachement = "Please Upload valid attachment";

    // Field validation messages
    forgotpassword = {
        'emailformcontrol': [
            { type: 'required', message: 'Please Enter Email.' },
            { type: 'email', message: 'Please Enter Valid Email.' }
        ],
    }
    login = {
        'emailFormControl': [
            { type: 'required', message: 'Username is required.' },
            { type: 'email', message: 'Enter valid Username.' }
        ],
        'passwordFormControl': [
            { type: 'required', message: ' Password is required.' },
            { type: 'minlength', message: 'Password must be at least 8 characters long.' },
            { type: 'pattern', message: ' Your password must contain at least one uppercase, one lowercase, one special character and one number.' }
        ],
    }

    groupByMessages = {
        'fieldsGroupBy': [
            { type: 'required', message: 'Fields is required.' }
        ]
    }

    orderByMessages = {
        'fieldsOrderBy': [
            { type: 'required', message: 'Fields is required.' }
        ],
        'arrangeOrderBy': [
            { type: 'required', message: 'Arrange is required.' }
        ]
    }

    changepassword = {
        'oldPassword': [
            { type: 'required', message: 'Current password is required.' },
            { type: 'whitespace', message: 'Space not allowed.' }
        ],
        'newPassword': [
            { type: 'required', message: 'Please enter new password.' },
            { type: 'pattern', message: 'Enter valid Password.' }
        ],
        'cPassword': [
            { type: 'required', message: 'Please Re-enter password.' },
            { type: 'equalTo', message: 'Password and Re-enter password did not match.' }
        ],
    }

    screenCreatorMessages = {
        'screenName': [
            { type: 'required', message: 'Screen Name is required.' },
            { type: 'whitespace', message: 'Screen Name should not contain any white spaces.' },
            { type: 'maxlength', message: 'Screen Name is exceed maximum length 50.' }
        ],
        'tableName': [
            { type: 'required', message: 'Table Name is required.' },
            { type: 'whitespace', message: 'Table Name should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Table Name is exceed maximum length 64.' }
        ],
        'tableID': [
            { type: 'required', message: 'Table ID is required.' },
            { type: 'whitespace', message: 'Table ID should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Table ID is exceed maximum length 64.' }
        ],
        'numberOfColumnsInRow': [
            { type: 'required', message: 'Please Select Number Of Columns In Row.' },
        ],
        'screenImageName': [
            { type: 'required', message: 'Screen Image is required.' }
        ]
    }

    screenCreatorDataMessages = {
        'columnName': [
            { type: 'required', message: 'Field Name is required.' },
            { type: 'whitespace', message: 'Field Name should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Field Name is exceed maximum length 64.' }
        ],
        'displayFormColumnName': [
            { type: 'required', message: 'Form Name is required.' },
            { type: 'whitespace', message: 'Form Name should not contain any white spaces.' }
        ],
        'formColumnShow': [
            { type: 'required', message: 'Please Select Show Form.' },
        ],
        'displayAgGridColumnName': [
            { type: 'required', message: 'AgGrid Name is required.' },
            { type: 'whitespace', message: 'AgGrid Name should not contain any white spaces.' }
        ],
        'agGridColumnShow': [
            { type: 'required', message: 'Please Select Show AgGrid.' }
        ],
        'isRequired': [
            { type: 'required', message: 'Please Select Required.' }
        ],
        'isUnique': [
            { type: 'required', message: 'Please Select Unique.' }
        ],
        'maximumLength': [
            { type: 'required', message: 'Maximum Length is required.' },
            { type: 'whitespace', message: 'Maximum Length should not contain any white spaces.' },
            { type: 'max', message: 'Maximum Length is exceed maximum length.' },
            { type: 'pattern', message: 'Maximum Length allows only positive integers.' }
        ],
        'maximumValue': [
            { type: 'required', message: 'Maximum Value is required.' },
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'max', message: 'Maximum value is exceed.' }
        ],
        "maximumDecimalValue": [
            { type: 'required', message: 'Maximum Decimal Value is required.' },
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'max', message: 'Maximum value is exceed.' }
        ],
        'endDateName': [
            { type: 'required', message: 'End Date is required.' },
            { type: 'whitespace', message: 'End Date should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'End Date is exceed maximum length 64.' }
        ],
        'startDateName': [
            { type: 'required', message: 'Start Date is required.' },
            { type: 'whitespace', message: 'Start Date should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Start Date is exceed maximum length 64.' }
        ],
        'endDateTimeName': [
            { type: 'required', message: 'End Date Time is required.' },
            { type: 'whitespace', message: 'End Date Time should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'End Date Time is exceed maximum length 64.' }
        ],
        'startDateTimeName': [
            { type: 'required', message: 'Start Date Time is required.' },
            { type: 'whitespace', message: 'Start Date Time should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Start Date Time is exceed maximum length 64.' }
        ],
        'dropDownTableName': [
            { type: 'required', message: 'Please Select DropDown Table Name.' }
        ],
        'dropDownIDs': [
            { type: 'required', message: 'DropDown IDs is required.' },
            { type: 'whitespace', message: 'DropDown IDs should not contain any white spaces.' }
        ],
        'dropDownValues': [
            { type: 'required', message: 'Please Select DropDown Values.' }
        ],
        'dropDownChildFieldName': [
            { type: 'required', message: 'Child DropDown Field Name is required.' },
            { type: 'whitespace', message: 'Child DropDown Field Name should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Child DropDown Field Name is exceed maximum length 64.' }
        ],
        'imageName': [
            { type: 'required', message: 'File Name is required.' },
            { type: 'whitespace', message: 'File Name should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'File Name is exceed maximum length 64.' }
        ],
        'maximumDate': [
            { type: 'required', message: 'Maximum Date is required.' }
        ],
        'maximumDateTime': [
            { type: 'required', message: 'Maximum Date Time is required.' }
        ]
    }

    screenCreatorTransactionMessages = {
        'screenName': [
            { type: 'required', message: 'Screen Name is required.' },
            { type: 'whitespace', message: 'Screen Name should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Screen Name is exceed maximum length 64.' }
        ],
        'displayName': [
            { type: 'required', message: 'Display Name is required.' },
            { type: 'whitespace', message: 'Display Name should not contain any white spaces.' },
            { type: 'maxlength', message: 'Display Name is exceed maximum length 50.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'numberOfColumnsInRow': [
            { type: 'required', message: 'Please Select Number Of Columns In Row.' },
        ],
        'screenImageName': [
            { type: 'required', message: 'Screen Image is required.' },
        ]
    }

    numberOfFormsMessages = {
        'numberOfForms': [
            { type: 'required', message: 'Number Of Forms is required.' },
            { type: 'pattern', message: 'Please enter postive integer.' },
            { type: 'max', message: 'Number Of Forms maximum value is 100.' },
            { type: 'min', message: "Number Of Forms minimum value is 1." }
        ]

    }

    concreteUpdateReportMessages = {
        'materialcategoryid': [
            { type: 'required', message: 'Material categories is required.' }
        ],
        'date': [
            { type: 'required', message: 'Select date type is required.' }
        ],
        'requisitionstatus': [
            { type: 'required', message: 'Requistion Status is required.' }
        ],
        'orderstatus': [
            { type: 'required', message: 'Order Status is required.' }
        ],
        'issuedquantity': [
            { type: 'required', message: 'Dispatch Quantity is required.' },
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'min', message: 'Dispatched quantity should be greater than or equal to one.' },
            { type: 'max', message: 'Max Number of value reached.' },
        ],
        'dispatchnumber': [
            { type: 'required', message: 'Dispatch Number is required.' },
            { type: 'pattern', message: 'Please enter numeric value.' },
        ],
        'materialquality': [
            { type: 'required', message: 'Material Quality is required.' },
            { type: 'whitespace', message: 'Material Quality should not contain any white spaces.' }
        ],
        'quantity': [
            { type: 'required', message: 'Quantity is required.' },
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'min', message: 'Quantity should be greater than or equal to one.' },
            { type: 'max', message: 'Max Number of value reached.' },

        ],
        'batchplantid': [
            { type: 'required', message: 'Batch Plant is required.' }
        ],
        'retstoreqty': [
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'max', message: 'Max Number of value reached.' },
        ],
        'scrapqty': [
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'max', message: 'Max Number of value reached.' },
        ],
        'precessqty': [
            { type: 'pattern', message: 'Please enter numeric value.' },
            { type: 'max', message: 'Max Number of value reached.' },
        ],
        'remarks': [
            { type: 'required', message: 'Remarks is required.' },
            { type: 'whitespace', message: 'Remarks should not contain any white spaces.' },
        ],
      'assignuserroleid': [
        { type: 'required', message: 'User Role is required.' }
      ],
      'userid': [
        { type: 'required', message: 'User Name is required.' }
        ],
        'tenantid': [
            { type: 'required', message: 'DNS Name is required.' }
        ],
        'companyid': [
            { type: 'required', message: 'Company Name is required.' }
        ],
        'dnsId': [
            { type: 'required', message: 'Workspace Name is required.' }
        ],
    }

    deleteScreenNameMessages = {
        'screenName': [
            { type: 'required', message: 'Screen Name is required.' },
            { type: 'whitespace', message: 'Screen Name should not contain any white spaces.' },
            { type: 'pattern', message: 'Please enter only lower case alphabets.' },
            { type: 'maxlength', message: 'Screen Name is exceed maximum length 64.' }
        ]
    }

    profileMessages = {
        'phoneNumber': [
            { type: 'required', message: 'Phone Number is required.' },
            { type: 'whitespace', message: 'Phone Number should not contain any white spaces.' },
            { type: 'maxlength', message: 'Phone Number is exceed maximum length 15.' }
        ]
    }

    reportMessages = {
        'dataSet': [
            { type: 'required', message: 'Dataset Name is required.' },
            { type: 'whitespace', message: 'Dataset Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Dataset Name is exceed maximum length 100.' }
        ]
    }
    templatecreationmessages = {
        'templatename': [
            { type: 'required', message: 'Template Name is required.' },
            { type: 'whitespace', message: 'Template Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Template Name is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'reportname': [
            { type: 'required', message: 'Report Name is required.' },
            { type: 'whitespace', message: 'Report Name should not contain any white spaces.' },
            { type: 'maxlength', message: 'Report Name is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'selectschedule': [
            { type: 'required', message: 'Select Schedule field is required.' }
        ],
        'selectfilter': [
            { type: 'required', message: 'Select filter field is required.' }
        ]
    }

    schedulerReportMessages = {
        'reportname': [
            { type: 'required', message: 'Report Name is required.' },
            { type: 'whitespace', message: 'Report Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Report Name is exceed maximum length 150.' }
        ],
        'date': [
            { type: 'required', message: 'Select schedule frequency is required.' }
        ],
        'reporttypeid': [
            { type: 'required', message: 'Report Type is required.' }
        ],
        'reportreferenceid': [
            { type: 'required', message: 'Report Reference is required.' }
        ],
        'productid': [
            { type: 'required', message: 'Products is required.' }
        ],
        'authoritiesid': [
            { type: 'required', message: 'Authorities is required.' }
        ],
        'scheduletime': [
            { type: 'required', message: 'Schedule Time is required.' }
        ],
    }

        reportConfiguration = {
        'selectdataSet': [
            { type: 'required', message: 'Select Dataset is required.' },
            { type: 'whitespace', message: 'Select Dataset  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Select Dataset is exceed maximum length 150.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
          'datasetOutputFormat': [
    { type: 'required', message: 'Dataset output format is required' }
  ],

        'description': [
            { type: 'required', message: 'Description is required.' },
            { type: 'whitespace', message: 'Description  should not contain any white spaces.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'sourceDNS': [
            { type: 'required', message: 'SourceDNS is required.' },
            { type: 'whitespace', message: 'SourceDNS  should not contain any white spaces.' }
        ],
        'type': [
            { type: 'required', message: 'Type is required.' },
            { type: 'whitespace', message: 'Type  should not contain any white spaces.' }
        ],
        'dataLakeType': [
            { type: 'required', message: 'Data Lake Type is required.' },
            { type: 'whitespace', message: 'Data Lake Type  should not contain any white spaces.' }
        ],
        'groupname': [
            { type: 'required', message: 'Groupname is required.' },
            { type: 'whitespace', message: 'Groupname  should not contain any white spaces.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'objectGroup': [
            { type: 'required', message: 'Object Group is required.' },
            { type: 'whitespace', message: 'Object Group  should not contain any white spaces.' }
        ],
        'groupExtractionType': [
            { type: 'required', message: 'Group Extraction Type is required.' },
            { type: 'whitespace', message: 'Group Extraction Type should not contain any white spaces.' }
        ],'setsSplitRequired': [
            { type: 'required', message: 'Set Split Required is required.' },
            { type: 'whitespace', message: 'Set Split Required should not contain any white spaces.' }
        ],
        'csvtojsoncsvpartitionname': [
            { type: 'required', message: 'Partition By is required' },
            { type: 'whitespace', message: 'Partition By should not contain any white spaces.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'csvtojsonpartitionsubstringstartposition': [
            { type: 'required', message: 'Start Position is required.' },
            { type: 'whitespace', message: 'Start Position should not contain any white spaces.' }
        ],
        'csvtojsonpartitionsubstringlength': [
            { type: 'required', message: 'Partition Length is required.' },
            { type: 'whitespace', message: 'Partition Length should not contain any white spaces.' }
        ],
        'extractionsource': [
            { type: 'required', message: 'Extraction Method is required.' },
            { type: 'whitespace', message: 'Extraction Method should not contain any white spaces.' }
        ], 
        'fieldsfromobjectmetadata': [
            { type: 'required', message: 'Fields From Objectmetadata is required.' },
            { type: 'whitespace', message: 'Fields From Objectmetadata should not contain any white spaces.' }
        ],
        'splitby': [
            { type: 'required', message: 'splitby  is required.' },
            { type: 'whitespace', message: 'splitby should not contain any white spaces.' }
        ],
        'csvextractionsource': [
            { type: 'required', message: 'CSV Extraction Method is required.' },
            { type: 'whitespace', message: 'CSV Extraction Method should not contain any white spaces.' }
        ], 
        'selectfacet': [
            { type: 'required', message: 'Select Facet is required.' },
            { type: 'whitespace', message: 'Select Facet  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Select Facet is exceed maximum length 150.' },
            { type: 'pattern', message: 'Special characters are not allowed.' }
        ],
        'selectstageobject': [
            { type: 'required', message: 'Select Object Label is required.' },
            { type: 'whitespace', message: 'Select Object Label  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Select Object Label is exceed maximum length 150.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'selectobjectname': [
            { type: 'required', message: 'Select Object Name is required.' },
            { type: 'whitespace', message: 'Select Object Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Select Object Name is exceed maximum length 150.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'pivotColumnAlias': [
            { type: 'required', message: 'Column Alias is required' },
        ],
        'caseColumn':  [
            { type: 'required', message: 'Case Column is required' },
        ],
        'pivotColumn':  [
            { type: 'required', message: 'Pivot Column is required' },
        ],
        'childColumns':  [
            { type: 'required', message: 'Child Columns is required' },
        ],
        'headersToNull':  [
            { type: 'required', message: 'Headers To Null is required' },
        ],
        'orderByColumn':  [
            { type: 'required', message: 'Order By Column is required' },
        ],
        'parentcolumns':  [
            { type: 'required', message: 'Parent Columns is required' },
        ],
        'headerValueColumn':  [
            { type: 'required', message: 'Header Value Column is required' },
        ],
        'distinctCount':  [
            { type: 'required', message: 'Distinct count is required' },
        ],
        'pivotAlias':  [
            { type: 'required', message: 'Pivot Column Alias is required' },
        ],
        'orderId':  [
            { type: 'required', message: 'Order Id is required' },
        ],
        'objectGroupName':  [
            { type: 'required', message: 'Object Group is required' },
        ]
    }

    filterMessages = {
        'filtername': [
            { type: 'required', message: 'Filter Name is required.' },
            { type: 'whitespace', message: 'Filter Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Filter Name is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'filterdescription': [
            { type: 'required', message: 'FIlter Description is required.' },
            { type: 'whitespace', message: 'FIlter Description  should not contain any white spaces.' },
            { type: 'maxlength', message: 'FIlter Description is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'selectdataSet': [
            { type: 'required', message: 'Select Dataset is required.' }
        ],
        'setAsDefaultFilter': [
            { type: 'required', message: 'Default Filter is required.' }
        ],
        's3Path': [
            { type: 'required', message: 'S3 Path is required.' },
            { type: 'whitespace', message: 'S3 Path  should not contain any white spaces.' },
            { type: 'maxlength', message: 'S3 Path is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'mappingtypename': [
            { type: 'required', message: 'S3 Path is required.' },
            { type: 'whitespace', message: 'S3 Path  should not contain any white spaces.' },
            { type: 'maxlength', message: 'S3 Path is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
    }
    toolConfiguration ={
        'sourceFolder': [
            { type: 'required', message: 'Source Folder Path  is required.' },
            { type: 'whitespace', message: 'Source Folder Path should not contain any white spaces.' },
            { type: 'maxlength', message: 'Source Folder Path is exceed maximum length 100.' }
        ],
        'destFolder': [
            { type: 'required', message: 'Destination Folder Path is required.' },
            { type: 'whitespace', message: 'Destination Folder Path  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Destination Folder Path is exceed maximum length 100.' }

        ],
        'csvFileFolder': [
            { type: 'required', message: 'CSV File Folder Path is required.' },
            { type: 'whitespace', message: 'CSV File Folder Path  should not contain any white spaces.' },
            { type: 'maxlength', message: 'CSV File Folder Path is exceed maximum length 100.' }

        ],
        'databasename': [
            { type: 'required', message: 'Database Name is required.' },
            { type: 'whitespace', message: 'Database Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Database Name  is exceed maximum length 100.' },
            { type: 'pattern', message: 'Only [a-z, A-Z, 0-9] can be used as database names. ' }

        ],
        'action': [
            { type: 'required', message: 'Action is required.' },

        ],
        'objectName':[
            {type:'required', message:'Object Name is required.'},
        ]


    }

    objectattributes={
        'databasename':[
            { type: 'required', message: 'Database Name is required.' },
            { type: 'whitespace', message: 'Database Name  should not contain any white spaces.' },
            { type: 'maxlength', message: 'Database Name is exceed maximum length 100.' }
        ],
        'name':[
            { type: 'required', message: 'Name is required.' },
            { type: 'maxlength', message: 'Name is exceed maximum length 100.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'objectGroup':[
            { type: 'required', message: 'Object Group is required.' }
        ]
    }
    E2B={
        'filename':[
            { type: 'required', message: 'Excel file is required.' }
        ],
        'type':[
            { type: 'required', message: 'Please select type.' }
        ],
        'object':[
            { type: 'required', message: 'Please select object name.' }
        ],
        'operation':[
            { type: 'required', message: 'Please select API operation.' }
        ]
    }
    dnsConfiguration={
        'compname':[
            { type: 'required', message: 'Company Name is required.' },
        ],
        'username':[
            { type: 'required', message: 'User Name is required.' },
        ]
    }

    etlTool={
        'imageName':[
            {type:'required' , message:'Excel file required'}
        ],
        'filterquery':[
            { type: 'required', message: 'Please enter filters to apply.' },
            { type: 'maxlength', message: 'Filter is exceed maximum length 1000.' },
            { type: 'minlength', message: 'Filter must be of minimum length 10.' }
        ]
    }

  //It is for permissions screen.
  permissionsMessage = {
    'userId': [
      { type: 'required', message: 'Role Name is required.' }
    ]
  }
  migrationRunDetailsPopup = {
    'comment':[
      { type: 'maxlength', message: 'Comment is exceed maximum length 100.' },
      { type: 'minlength', message: 'Comment must be of minimum length 15.' }

    ]
  }
  addSetForMigrationPopup = {
    'setNumber':[
      { type: 'pattern', message: 'Set Number must follow 1 to 9 or 1-2,1,45 pattern! ' },
      { type: 'required', message: 'Set Number is required' },
      { type: 'min', message: 'Set Number cannot be assigned to 0.' },
    ]
  }

  startMigrationPopup ={
    'source':[
        {type: 'required', message: 'Source is required'}
    ],
    'target':[
        {type: 'required', message: 'Target is required'}
    ],
    'migrationType':[
        {type: 'required', message: 'Migration Type is required'}
    ],
    'snapshotVersion':[
        {type: 'required', message: 'Snapshot is required'}
    ],
     'dataExtractionType':[
        {type:'required', message:'Data Extraction Type is required'}
    ],
    'remarks':[
        {type:'required', message:'Remarks is required'},
        { type: 'whitespace', message: 'Remarks should not contain any white spaces.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'objectGroups':[
        {type:'required', message:'Object Groups Names are required'}
    ],
    'dataLakeAndReports':[
        {type:'required', message:'Data Lake And Reports is required'}
    ],
    'dataLakeType':[
        {type:'required', message:'Data Lake Type is required'}
    ],
    'DatasetName':[
        {type:'required', message:'DatasetName is required'}
    ],
    'selectdataSet':[
        {type:'required', message:'Remarks is required'}
    ],
    'persistenceEmr': [
        {type:'required', message:'Persistence EMR is required'}
    ],
    'JSONTOCSV_Validation_Reports':[
        {type:'required', message:'JSONTOCSV Validation Reports is required'}
    ]
  }

  webScraping ={
    'dnsName':[
        {type: 'required', message: 'Domain is required'}
    ],
    'Version':[
        {type: 'required', message: 'Vault Version is required'}
    ],
    'caseName':[
        {type: 'required', message: 'Case Name is required'}
    ],
    'AERName':[
        {type: 'required', message: 'AER Name is required'}
    ],
    'documentName':[
        {type: 'required', message: 'Document Name is required'}
    ],
    'Description':[
        {type: 'required', message: 'Description is required'}
    ],
  }

  vaultObjectRelationship={
    'objectName':[
        {type: 'required', message: 'Object Name is required'}
    ],
    'parentObjectName':[
        {type: 'required', message: 'Parent Object Name is required'}
    ],
    'uniqueKeyColumn':[
        {type: 'required', message: 'Unique Key Column is required'},


        { type: 'whitespace', message: 'Unique Key should not contain any white spaces.' },

        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'columnsFromParentFile':[
        {type: 'required', message: 'Columns From Parent File is required'},

        { type: 'whitespace', message: 'Columns From Parent File should not contain any white spaces.' },

        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'parentRefColumn':[
        {type: 'required', message: 'Parent Ref Column is required'},

        { type: 'whitespace', message: 'Parent Ref Column should not contain any white spaces.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'childFileName':[
        {type: 'required', message: 'Child File Name is required'},
        { type: 'whitespace', message: 'Child File Name should not contain any white spaces.' },

        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'parentFileName':[
        {type: 'required', message: 'Parent File Name is required'},

        { type: 'whitespace', message: 'Parent File Name should not contain any white spaces.' },

        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'uniquekeycolumnd2dvalidation':[
        {type: 'required', message: 'Unique key Column D2D Validation is required'},

    ],
  }

/* Sneha
*  AWS Scret Popup Validation Messages
*  10-01-2024
*/
  awsSecretPopup = {
    'dns': [
        { type: 'required', message: 'DNS is required.' },
        { type: 'whitespace', message: 'DNS should not contain any white spaces.' }
    ],
    'secretname': [
        { type: 'required', message: 'Secret Name is required.' },
        { type: 'whitespace', message: 'Secret Name should not contain any white spaces.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'region': [
        { type: 'required', message: 'Region is required.' },
        { type: 'whitespace', message: 'Region should not contain any white spaces.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
}


retportTemplatecreationmaster={
    'reportTemplateName':[
        {type: 'required', message: 'Template Name is required'},
        { type: 'whitespace', message: 'Template Name should not contain any white spaces.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'reportTemplateDescription':[
        {type: 'required', message: 'Template Description is required'},
        { type: 'whitespace', message: 'Template Name should not contain any white spaces.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
    'reportType':[
        {type: 'required', message: 'Report Type is required'}
    ],
    'vaultBinderTemplate':[
        {type: 'required', message: 'vault Binder Template is required'}
    ],
    'parentTemplateId':[
        {type: 'required', message: 'Parent Template is required'}
    ],
    'datasetId':[
        {type: 'required', message: 'Dataset is required'}
    ],
    'templateFile':[
        {type: 'required', message: 'Template File is required'}
    ],
    'templateType':[
        {type: 'required', message: 'Template Type is required'}
    ],
    'quickSightReference':[
        {type: 'required', message: 'Quick Sight Reference is required'},

        { type: 'whitespace', message: 'Quick Sight should not contain any white spaces.' }

    ],
    'documentDocTypeLabel':[
        {type: 'required', message: 'Doc Type is required'}
    ],
    'documentDocSubTypeLabel':[
        {type: 'required', message: 'Doc Sub Type is required'}
    ],
    'documentDocClassificationLabel':[  
        {type: 'required', message: 'Doc Classification is required'}
    ],

    'documentDocLifecycle': [
        { type: 'required', message: 'Doc Lifecycle is required' }

    ],
'reportOutputFormat': [
    { type: 'required', message: 'Report Dataset Output Format is required' }
  ],

    'configFile': [
        { type: 'required', message: 'Config File is required' }
    ],
    'binderType': [
        { type: 'required', message: 'Binder Type is required' }
    ],
    'mergeReports': [
        { type: 'required', message: 'Merge Reports is required' }
    ],

  }

 /**
   * Modified By Vijay B
   * 08/07/2024
   * Validations for Filter Popup
   */
  selectFilterPopup={
    'value':[
        {type: 'required', message: 'value is required'}
    ],
    'selectVisual': [
        { type: 'required', message: 'Please select any visual' }
    ],
    'reportname': [
        { type: 'whitespace', message: 'Report Name should not contain any white spaces.' },
        { type: 'maxlength', message: 'Report Name is exceed maximum length 100.' },
        { type: 'specialCharacter', message: 'Special characters are not allowed.' }
    ],
  }

  /**
   * Modified By Ashwin M
   * 08/07/2024
   * code modified to add validation messages for object level deletion
   */
  caseDeletionPopup = {
    'imageName': [
        { type: 'required', message: 'Parent Ids File is required.' },
        { type: 'whitespace', message: 'Parent Ids File cannot be empty' }
    ],
    'object': [
        { type: 'required', message: 'Parent Object is required.' },
        { type: 'whitespace', message: 'Parent Object should not contain any white spaces.' }
    ],
}

 pivotConfiguration = {
        
        'selectdataSet': [
            { type: 'required', message: 'Dataset is required.' }
        ],
        'visualName': [
            { type: 'required', message: 'Visual Name is required.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'selectVisualType': [
            { type: 'required', message: 'Visual Type is required.' }
        ],
    }

    mappingAttributes = {
        
        'objects': [
            { type: 'required', message: 'Mapped Object is required.' }
        ],
        'mappingType': [
            { type: 'required', message: 'Mapping Type is required.' }
        ],
        'fieldOrderId': [
            { type: 'required', message: 'Field Order Id is required.' }
        ],
        'codelistname': [
            { type: 'required', message: 'Codelist Name is required.' }
        ],
        'selectStageObjectsForm': [
            { type: 'required', message: 'Stage Object is required.' }
        ],
        'selectStageObjectsAttributesForm': [
            { type: 'required', message: 'Attribute is required.' }
        ],
        'query': [
            { type: 'required', message: 'Query is required.' }
        ],
        'codelistValueType':[
            { type: 'required', message: 'Codelist Value Type is required.' }
        ],
        'codelistValueTypeConstant':[
            { type: 'required', message: 'Constant is required.' }
        ]

        
    }
 
    valueMapping = {
        
        'sourceOrTarget': [
            { type: 'required', message: 'Source Or Target is required.' }
        ],
        'headerName': [
            { type: 'required', message: 'Header Name is required.' }
        ],
        'dataType': [
            { type: 'required', message: 'Data type is required.' }
        ],
        'keyOrder': [
            { type: 'required', message: 'Key Order is required.' }
        ]
    }

    createAttributes = {
        
        'attributeName': [
            { type: 'required', message: 'Name is required.' }
        ],
        'attributeLabel': [
            { type: 'required', message: 'Label is required.' }
        ]
    }

    passwordPolicies = {
        
        'resetlimit': [
            { type: 'min', message: 'Reset Limit should not be less than 5' }
        ],
        'lastpasswordchecking': [
            { type: 'min', message: 'Compare No of Last Passwords should not be less than 5' }
        ],
        'lockoutvalue':[
            {type: 'min',message: 'Lockout Value must be greater than 0'}
        ]
    }
     sqlscripts = {
        'sqlscript__j': [
            { type: 'required', message: 'SQL Qeury is required.' },
            { type: 'whitespace', message: 'SQL Qeury should not contain any white spaces.' }
        ],
        'automatically_formate' : [
            { type: 'required', message: 'Format Date is required.' }
        ],
        'filename__j' : [
            { type: 'required', message: 'File Name is required.' },
            { type: 'whitespace', message: 'File Name  should not contain any white spaces.' }
        ],
        'executionorder__j': [
             { type: 'required', message: 'Execution Order is required.' },
            { type: 'pattern', message: 'Execution order must be a positive integer' }
        ],
        'attachmentquery__j' : [
            { type: 'required', message: 'Attachment Query is required.' }
        ],
        'extractiontype__j' : [
             { type: 'required', message: 'Extraction Type is required.' }
        ],
        'isExecutable__j' : [
            {type: 'required', message:'Is Executable is required.'}
        ],
        'queryexecutiontype__j' : [
            {type: 'required', message:'Query Execution Type is required.'},
            { type: 'whitespace', message: 'Query Execution Type should not contain any white spaces.' }
        ],
        'sourceconnectionstring__j' : [
            {type: 'required', message:'Data Source Name is required.'},
            { type: 'whitespace', message: 'Data Source Name should not contain any white spaces.' }
        ],
        'sourcetype__j' : [
            {type: 'required', message:'Data Source Type is required.'},
            { type: 'whitespace', message: 'Data Source Type should not contain any white spaces.' }
        ],
        'objectgroupname' : [
            {type: 'required', message:'Group Name is required.'}
        ],
         'objectname' : [
            {type: 'required', message:'Object Name is required.'}
        ],
        'setssplitrequired': [
            {type: 'required', message:'Set Split Required is required.'}
        ],
        'groupextractiontype' : [
            {type: 'required', message:'Group Extraction Type is required.'}
        ]
    }
    /**
   * @Author- Asha Waghadure
   * @Date-03/12/2025
   * -to add validation messages for Manage MDL Script Screen
   */
    mdlscript = {
        'propertycategory': [
            { type: 'required', message: 'Property Category is required.' },
        ],
        'propertyname' : [
            { type: 'required', message: 'Property Name is required.' }
        ],
        'component_type' : [
            { type: 'required', message: 'Component Type is required.' },
        ],
        'createmdltemplate': [
             { type: 'required', message: 'MDL Template Create is required.' },
        ],
        'updatemdltemplate' : [
            { type: 'required', message: 'MDL Template Update is required.' }
        ]
        ,
         'executionorder' : [
            { type: 'required', message: 'Execution Order is required.' }
        ]
    }


    loadobjects = {
        'objectName': [
            { type: 'required', message: 'Object Name is required.' },
            { type: 'whitespace', message: 'Object Name should not contain any white spaces.' }
        ],
        'loadOrder': [
            { type: 'required', message: 'Load Order is required.' },
            { type: 'whitespace', message: 'Load Order should not contain any white spaces.' },
            { type: 'pattern', message: 'Load order must be a positive integer' }
        ],
         'level': [
            { type: 'required', message: 'Object Level is required.' },
            { type: 'whitespace', message: 'Object Level  should not contain any white spaces.' },
             { type: 'pattern', message: 'level must be a positive integer' }
        ],
         'vaultExtraction': [
            { type: 'required', message: 'Vault Extraction is required.' },
            { type: 'whitespace', message: 'Vault Extraction should not contain any white spaces.' }
        ],
         'objectType': [
            { type: 'required', message: 'Object Type is required.' },
            { type: 'whitespace', message: 'Object Type should not contain any white spaces.' }
        ],
         'fileName': [
            { type: 'required', message: 'File Name is required.' },
            { type: 'whitespace', message: 'File Name should not contain any white spaces.' }
        ]
    }

    lifecycle= {
        'lifecyclename': [
            { type: 'required', message: 'Lifecycle Name is required.' },
            { type: 'whitespace', message: 'Lifecycle Name should not contain any white spaces.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ]
        
    }

    workflow = {
        'workflowname': [
            { type: 'required', message: 'Workflow Name is required.' },
            { type: 'whitespace', message: 'Workflow Name should not contain any white spaces.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'lifecyclename': [
            { type: 'required', message: 'Lifecycle Name is required.' }
        ],
        'startstates': [
            { type: 'required', message: 'Start Startes is required.' }
        ],
        'stepname':[
              { type: 'required', message: 'Step Name is required.' },
              { type: 'whitespace', message: 'Step Name should not contain any white spaces.' },
              { type: 'specialCharacter', message: 'Special characters are not allowed.' }
        ],
        'steptype':[
            { type: 'required', message: 'Step Type is required.' }
        ],
        'nextsteps':[
            { type: 'required', message: ' Next Step Name is required.' }
        ],
        'taskmode':[
            { type: 'required', message: 'Task Mode is required.' }
        ]

    }
    
    reviewActivityConfig = {
        
        'activityType': [
            { type: 'required', message: 'Activity Type is required.' }
        ],
        'activityName': [
            { type: 'required', message: 'Activity Name is required.' },
            { type: 'specialCharacter', message: 'Special characters are not allowed.' },
             { type: 'whitespace', message: 'Activity Name  should not contain any white spaces.' },
        ],
        'dataset': [
            { type: 'required', message: 'Dataset is required.' }
        ],
        'visual': [
            { type: 'required', message: 'Visual is required.' }
        ],
        'reportTemplate': [
            { type: 'required', message: 'Report Template is required.' }
        ]
    }

      productGroupMapping = {
        'productGroupNameControler': [
            { type: 'required', message: 'Product group name is required.' }
        ],
    }

}
